export default __webpack_public_path__ + "static/media/Carrie_Caulfield_Arick_AHV_In_Moms_We_Trust.fc181d9f.jpg";